<div class="layout-wrapper landing section intro-section pb-0">
  <div class="about-us-page" [dir]="translate.currentLang === 'ar' ? 'rtl' : 'ltr'">

    <section class="privacy-policy-section" style="padding: 3rem 2rem; background-color: #fff;">
      <div class="container">
        <h2 class="mb-4">{{ 'privacyPolicy.title' | translate }}</h2>
      <p class="hero-description" [innerHTML]="'privacyPolicy.content' | translate | replace:'\n':'<br>' | safeHtml"></p>
  
      </div>
    </section>
    
  </div>
  
</div>
